<template>
  <div class="noneBox">
    <div class="content">
      <div class="imgbox"></div>
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.noneBox {
  .content {
    .imgbox {
      background-image: url("../../assets/partyreports/kong.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 3.74rem;
      height: 2.88rem;
      margin: 0 auto;
    }
    p {
      font-size: 0.28rem;
      font-weight: 500;
      color: #666666;
    }
    width: 3.74rem;
    height: 3.3rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
  }

  width: 100%;
  height: 4.58rem;
  // background-color: rgb(244, 244, 244);
  position: relative;
}
</style>